<template>
  <a-modal
    :maskStyle="{ backgroundColor: 'rgba(10, 15, 26, 0.1)' }"
    v-model="visible"
    :footer="null"
    :closable="false"
    class="app-about"
  >
    <div class="about-box">
      <div class="title">{{ $t("personSetting.About") }}</div>
      <SvgIcon icon-class="logo-about" class-name="logo" />
      <div class="version">
        <span>{{version}}</span>
        <span> {{$t("login.version")}}</span>
      </div>
      <div class="privacy">
        <a
          href="./protocol/service"
          target="_blank"
          style="color: #236CFF;font-weight: 500; margin-right: 5px;"
          >{{ $t("login.ServiceAgreement") }}</a
        >
        |
        <a
          href="./protocol/privacy"
          target="_blank"
          style="color: #236CFF;font-weight: 500; margin-left: 5px;"
          >{{ $t("login.PrivacyPolicyNo") }}</a
        >
      </div>
      <div class="statement">亮风台信息科技 版权所有</div>
      <div class="copyright">Copyright © 2020 HiAR. All Rights Reserved</div>
    </div>
  </a-modal>
</template>

<script>
import Global from '@/global'
export default {
  name: 'AppAbout',

  data() {
    return {
      visible: false,
      version: Global.VERSION
    }
  },
  methods: {
    openModal() {
      this.visible = true
    }
  }
}
</script>

<style scoped lang="less">
.app-about {
  ::v-deep .ant-modal {
    min-width: 819px;
    padding: 0;

    .ant-modal-content {
      box-shadow: 0px 5px 30px 0px rgba(89, 132, 219, 0.08);
    border-radius: 16px;
    border: 1px solid #edeff2;
    }
  }
  .about-box {
    text-align: center;

    .title {
      height: 40px;
      font-size: 28px;
      font-weight: 500;
      color: #333333;
      line-height: 40px;
    }
    .logo {
      margin-top: 35px;
      width: 160px;
      height: 160px;
    }
    .version {
      margin-top: 16px;
      font-size: 16px;
      font-weight: 400;
      color: #333333;
    }

    .privacy {
      margin-top: 80px;
      font-size: 16px;
      font-weight: 400;
    }

    .statement {
      margin-top: 16px;
      font-size: 16px;
      font-weight: 400;
      color: #333333;
    }
    .copyright {
      margin-top: 5px;
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      margin-bottom: 20px;
    }
  }
}
</style>
